import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';
import axios from 'axios';


// customizable method: use your own `Plotly` object
import createPlotlyComponent from 'react-plotly.js/factory';
//const Plot = createPlotlyComponent(Plotly);

import backend_url from "../../../../routes/API_URL";

import swal from 'sweetalert';


const API_URL = backend_url['api_url'];

var Plotly = require('plotly.js')
//var createPlotlyComponent = require('plotlyjs-react')
var Plot = createPlotlyComponent(Plotly)

//const API_URL = "http://localhost:8000/api";


class InspectedSchools extends Component {
    constructor(props) {
        super(props);
        
        // Extract data from props.summary or props directly
        const summary = props.summary || {};
        
        const date_object1 = new Date();
        const current_year1 = date_object1.getFullYear();

        this.state = {
            Prim_Data: summary.Prim_Data || props.Prim_Data || 0,
            Sec_Data: summary.Sec_Data || props.Sec_Data || 0,
            Visit_Data: summary.Visit_Data || props.Visit_Data || [],
            year: props.year_id,
            current_year1: current_year1,
            bearer_auth: window.sessionStorage.getItem('token'),
        };
    }

    componentDidUpdate(prevProps) {
        // Update state if props change
        if (prevProps.summary !== this.props.summary) {
            const summary = this.props.summary || {};
            this.setState({
                Prim_Data: summary.Prim_Data || this.props.Prim_Data || 0,
                Sec_Data: summary.Sec_Data || this.props.Sec_Data || 0,
                Visit_Data: summary.Visit_Data || this.props.Visit_Data || [],
            });
        }
    }

    render() {
        // Use state values directly
        const { Prim_Data, Sec_Data, Visit_Data } = this.state;

        // Debug logging
        console.log('InspectedSchools2 - Render state:', {
            Prim_Data,
            Sec_Data,
            Visit_Data,
            Visit_DataLength: Visit_Data ? Visit_Data.length : 0,
            Visit_DataSample: Visit_Data ? Visit_Data.slice(0, 3) : 'No data'
        });

        // If no data, show message
        if (!Visit_Data || Visit_Data.length === 0) {
            return (
                <div style={{
                    padding: '40px',
                    textAlign: 'center',
                    border: '2px dashed #ccc',
                    borderRadius: '8px',
                    margin: '20px'
                }}>
                    <h4>No Inspection Data Available</h4>
                    <p>No school visit data found for the chart.</p>
                    <p>This could be because:</p>
                    <ul style={{ textAlign: 'left', display: 'inline-block' }}>
                        <li>No school visits have been recorded yet</li>
                        <li>Visit data doesn't match your sector permissions</li>
                        <li>Visit dates are outside the 10-year range</li>
                    </ul>
                </div>
            );
        }

        const date_object = new Date();
        const current_year = date_object.getFullYear();
        const years = [];

        // Ensure we have valid data
        for (let i = 0; i < Visit_Data.length; i++) {
            if (Visit_Data[i] && Visit_Data[i].YEAR) {
                years.push(Visit_Data[i].YEAR);
            }
        }

        if (years.length === 0) {
            return (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                    <p>No valid year data found in visit records.</p>
                </div>
            );
        }

        const unique_years = [...new Set(years)].filter(year => year);

        // Handle division by zero or undefined
        const safePrimData = Prim_Data && Prim_Data > 0 ? Prim_Data : 1;
        const safeSecData = Sec_Data && Sec_Data > 0 ? Sec_Data : 1;

        let primaryData = { type: 'bar', mode: 'group', x: [], y: [], text: [], name: 'Primary Schools' };
        let secondaryData = { type: 'bar', mode: 'group', x: [], y: [], text: [], name: 'Secondary Schools' };

        for (let i = 0; i < Visit_Data.length; i++) {
            const item = Visit_Data[i];

            if (!item || !item.YEAR) continue;

            const yearDiff = parseInt(current_year - item.YEAR);

            if (yearDiff < 10 && yearDiff >= 0) {
                if (item.sector_id == '1') {
                    // Calculate percentage safely
                    const percentage = item.school_count / safePrimData;
                    primaryData.x.push(item.YEAR.toString());
                    primaryData.y.push(percentage);
                    primaryData.text.push(`Primary: ${item.school_count} schools (${(percentage * 100).toFixed(1)}%)`);
                } else if (item.sector_id == '2') {
                    // Calculate percentage safely
                    const percentage = item.school_count / safeSecData;
                    secondaryData.x.push(item.YEAR.toString());
                    secondaryData.y.push(percentage);
                    secondaryData.text.push(`Secondary: ${item.school_count} schools (${(percentage * 100).toFixed(1)}%)`);
                }
            }
        }

        // Check if we have any data to display
        if (primaryData.x.length === 0 && secondaryData.x.length === 0) {
            return (
                <div style={{
                    padding: '40px',
                    textAlign: 'center',
                    border: '2px dashed #ccc',
                    borderRadius: '8px',
                    margin: '20px'
                }}>
                    <h4>No Recent Inspection Data</h4>
                    <p>No school visits found within the last 10 years.</p>
                    <p>Recent visits are needed to display this chart.</p>
                </div>
            );
        }

        const data = [];
        if (primaryData.x.length > 0) data.push(primaryData);
        if (secondaryData.x.length > 0) data.push(secondaryData);

        const layout = {
            title: "INSPECTION PERCENTAGE FOR SCHOOLS OVER THE PAST 10 YEARS",
            autosize: true,
            xaxis: {
                type: 'category',
                title: 'YEAR',
                "categoryorder": "array",
                "categoryarray": unique_years.sort()
            },
            yaxis: {
                title: 'PERCENTAGE OF INSPECTED SCHOOLS',
                align: 'center',
                tickformat: ',.0%',
                range: [0, 1],
            },
            barmode: 'group',
            hovermode: 'closest',
            showlegend: true,
            legend: {
                orientation: 'h',
                y: -0.2
            }
        };

        const useResizeHandler = true;
        const style = { width: "100%", height: "500px" };

        return (
            <React.Fragment>
                <Plot
                    data={data}
                    layout={layout}
                    useResizeHandler={useResizeHandler}
                    style={style}
                />
                <div style={{
                    fontSize: '12px',
                    color: '#666',
                    marginTop: '10px',
                    padding: '10px',
                    backgroundColor: '#f5f5f5',
                    borderRadius: '4px'
                }}>
                    <strong>Chart Data Summary:</strong><br />
                    Primary Schools Total: {Prim_Data || 0}<br />
                    Secondary Schools Total: {Sec_Data || 0}<br />
                    Visit Records: {Visit_Data.length}<br />
                    Years with Data: {unique_years.sort().join(', ')}<br />
                    <small>Note: Inspector only sees data from their assigned sector</small>
                </div>
            </React.Fragment>
        );
    }
}

export default InspectedSchools;